export const TIMEZONE = 'Asia/Singapore';
export const DEFAULT_TIME_FORMAT = 'MMM DD YYYY, h:mm a';
export const BANNER_TEXT =
  'A framework for defining and running metric-driven sequential experiments.';
